import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Link, Stack, Typography, useTheme } from "@mui/material";
import { Row } from "react-bootstrap";
import { BoldFlash2 } from "../../../../Icon";
import { EGIconButton } from "../../../../MainComponents/Button/IconButton/IconButton";
import { EGBasicSelect } from "../../../../MainComponents/Select/EGBasicSelect";
import Comments from "../Comments";
import { HelpIcon } from "../../../../MainComponents/HelpIcon/HelpIcon";
import { catalogByPart } from "../../../../../apis";

export const Severity = ({
  selectedSeverityLvl,
  severityCatTransformed,
  severity,
  setSeverity,
  severityDetails,
  setSeverityDetails,
  reportDetail,
  editing,
  loading,
  details,
  setDetails,
  editIndicator,
  saveIndicatorInfo,
  openModalAction,
}) => {
  const [t] = useTranslation("information");
  const theme = useTheme();
  const lang = localStorage.getItem("lang") || "es";

  const [reasonForSeverityOptions, setReasonForSeverityOptions] = useState([]);

  // Cargar las opciones de razón de severidad desde el catálogo
  useEffect(() => {
    const loadReasonForSeverityOptions = async () => {
      try {
        const response = await catalogByPart({
          is_own: true,
          catalogue: "reasonForSeverity",
          path: "/",
        });

        if (response?.data && Array.isArray(response.data)) {
          const options = response.data
            .filter(item => item.is_active)
            .map(item => ({
              label: item.locales?.[lang] || item.label,
              value: item.key,
            }));
          setReasonForSeverityOptions(options);
        }
      } catch (error) {
        console.error("Error loading reason for severity options:", error);
      }
    };

    loadReasonForSeverityOptions();
  }, [lang]);

  const isSeveritySetted = !(
    selectedSeverityLvl === "type::none" || selectedSeverityLvl == null
  );

  // Función para obtener el label de un value del catálogo
  const getSeverityReasonLabel = (value) => {
    if (!value) return "";
    const option = reasonForSeverityOptions.find(opt => opt.value === value);
    return option?.label || value;
  };

  return isSeveritySetted ? (
    <Row className={`severity rounded dyTheme1 dyBorder1 mt-20 px-[8] py-[20]`}>
      <div className="severity__title">
        <Stack
          display="flex"
          direction="row"
          justifyContent="start"
          alignItems="center"
          spacing={1}
          sx={{ overflow: "hidden" }}
        >
          <Box sx={{ height: 24, width: 24 }}>
            <BoldFlash2 color={theme.palette.yellow.main} />
          </Box>

          <Box display="flex" alignItems="center">
            <div>
              <Typography
                style={{ display: "inline" }}
                color={theme.palette.blueGray700.main}
                component="p"
                fontSize={16}
                fontWeight={600}
              >
                {t("information.report_severity")}
              </Typography>
              <div style={{ display: "inline" }}>
                <HelpIcon
                  text={t("information.help_icon_severity")}
                  className="mx-[5] d-inline-block"
                />
              </div>
            </div>
          </Box>
        </Stack>
        <Stack
          direction="row"
          display="flex"
          alignItems="center"
          justifyContent="end"
          spacing={0.5}
          marginLeft={2}
        >
          {editing.severity && (
            <EGIconButton
              disabled={loading.severity}
              iconName="check_icon"
              title={t("information.save")}
              placement="bottom"
              color="success"
              iconColor="white"
              onClick={() =>
                openModalAction(
                  () => saveIndicatorInfo("severity"),
                  t("information.attention"),
                  t("information.you_about_modify_most_recently_data"),
                  t(
                    "information.this_action_is_irreversible_we_recommend_checking"
                  ),
                  t("information.do_you_want_continue")
                )
              }
              sx={{ height: 24, width: 24, padding: 0 }}
            />
          )}
          <EGIconButton
            disabled={loading.severity}
            iconName={`${editing.severity ? "close_icon" : "outline_edit"}`}
            iconColor={!editing.severity ? "secondary" : ""}
            color={`${editing.severity ? "error" : ""}`}
            title={
              editing.severity ? t("information.cancel") : t("information.edit")
            }
            placement="bottom"
            onClick={() => editIndicator("severity")}
            iconSize={editing.severity ? 23 : 16}
            sx={{ height: 24, width: 24, padding: 0 }}
          />
        </Stack>
      </div>
      <div>
        {editing.severity ? (
          <>
            <Box marginTop={2}>
              <EGBasicSelect
                value={severity}
                options={severityCatTransformed}
                onChange={(e) => setSeverity(e.target.value)}
                label="Tipo de criticidad"
                placeholder={t("information.not_defined")}
                // isValid={true}
                // required
                // showSuccessValidation
              />
            </Box>
            {details.severity ? (
              <Box marginTop={2}>
                <EGBasicSelect
                  label={`${t("information.add_severity_details")}:`}
                  placeholder={t("information.enter_details_for_severity")}
                  value={severityDetails}
                  options={reasonForSeverityOptions}
                  onChange={(e) => setSeverityDetails(e.target.value)}
                />
              </Box>
            ) : (
              <Stack display="flex" alignItems="end" marginTop="0.2rem">
                <Link
                  onClick={() =>
                    setDetails((prev) => ({
                      ...prev,
                      severity: true,
                    }))
                  }
                  underline="hover"
                >
                  + {t("information.add_severity_details")}
                </Link>
              </Stack>
            )}
          </>
        ) : (
          <div className="severity__info rounded mt-[20]">
            <Typography
              variant="span"
              fontWeight={600}
              fontSize={16}
              color={theme.palette.common.white}
              margin="15px auto 14px 20px"
            >
              {selectedSeverityLvl?.label || t("information.not_defined")}
            </Typography>
            {reportDetail?.severity.comment && (
              <div className="comment">
                <Comments
                  text={getSeverityReasonLabel(reportDetail?.severity.comment)}
                  background="white"
                  border="none"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </Row>
  ) : (
    <Row className={`severity rounded dyTheme1 dyBorder1 mt-20 px-[8] py-[20]`}>
      <div className="severity__title">
        <Stack
          display="flex"
          direction="row"
          justifyContent="start"
          alignItems="center"
          spacing={1}
          sx={{ overflow: "hidden" }}
        >
          <Box sx={{ height: 24, width: 24 }}>
            <BoldFlash2 color={theme.palette.yellow.main} />
          </Box>

          <Box display="flex" alignItems="center">
            <div>
              <Typography
                component="p"
                style={{ display: "inline" }}
                color={theme.palette.blueGray700.main}
                fontSize={16}
                fontWeight={600}
              >
                {t("information.report_severity")}
              </Typography>
              <div style={{ display: "inline" }}>
                <HelpIcon
                  text={t("information.help_icon_severity")}
                  className="mx-[5] d-inline-block"
                />
              </div>
            </div>
          </Box>
        </Stack>
        <Stack
          direction="row"
          display="flex"
          alignItems="center"
          justifyContent="end"
          spacing={1}
          marginLeft={2}
        >
          {severity !== "" && (
            <EGIconButton
              disabled={loading.severity}
              iconName="check_icon"
              title={t("information.save")}
              placement="bottom"
              color="success"
              iconColor="white"
              onClick={() =>
                openModalAction(
                  () => saveIndicatorInfo("severity"),
                  t("information.attention"),
                  t("information.you_about_modify_most_recently_data"),
                  t(
                    "information.this_action_is_irreversible_we_recommend_checking"
                  ),
                  t("information.do_you_want_continue")
                )
              }
              sx={{ height: 24, width: 24, padding: 0 }}
            />
          )}
        </Stack>
      </div>
      <div className={`${editing.severity ? "mt-[10]" : "my-0"}`}>
        <>
          <Box marginTop={2}>
            <EGBasicSelect
              value={severity}
              options={severityCatTransformed}
              onChange={(e) => setSeverity(e.target.value)}
              label="Tipo de criticidad"
              placeholder={t("information.not_defined")}
              // required
              // isValid={!!severity}
              // showSuccessValidation
              // showHelpText={false}
            />
          </Box>
          {details.severity ? (
            <Box marginTop={2}>
              <EGBasicSelect
                label={`${t("information.add_severity_details")}:`}
                placeholder={t("information.enter_details_for_severity")}
                value={severityDetails}
                options={reasonForSeverityOptions}
                onChange={(e) => setSeverityDetails(e.target.value)}
                // required
                // isValid={true}
                // showSuccessValidation={true}
                // showHelpText={false}
              />
            </Box>
          ) : (
            severity !== "" && (
              <Stack display="flex" alignItems="end" marginTop="0.2rem">
                <Link
                  onClick={() =>
                    setDetails((prev) => ({
                      ...prev,
                      severity: true,
                    }))
                  }
                  underline="hover"
                >
                  + {t("information.add_severity_details")}
                </Link>
              </Stack>
            )
          )}
        </>
      </div>
    </Row>
  );
};
